import React, { useEffect, useRef } from 'react';
import './CitationTooltip.css';

/**
 * Floating tooltip showing citation source details.
 * Positioned near the click target element.
 */
const CitationTooltip = ({ cite, position, onClose }) => {
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  useEffect(() => {
    if (!tooltipRef.current || !position) return;
    const rect = tooltipRef.current.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    if (rect.right > vw - 8) {
      tooltipRef.current.style.left = `${Math.max(8, vw - rect.width - 8)}px`;
    }
    if (rect.bottom > vh - 8) {
      tooltipRef.current.style.top = `${Math.max(8, position.top - rect.height - 8)}px`;
    }
  }, [position]);

  if (!cite || !position) return null;

  const pages = cite.pages?.length
    ? cite.pages.join(', ')
    : null;

  return (
    <div
      ref={tooltipRef}
      className="citation-tooltip"
      style={{ top: position.top, left: position.left }}
    >
      <div className="citation-tooltip-header">
        <span className="citation-tooltip-num">[{cite.cite_num}]</span>
        {cite.label && <span className="citation-tooltip-label">{cite.label}</span>}
        <button className="citation-tooltip-close" onClick={onClose}>&times;</button>
      </div>
      {cite.source_doc && (
        <div className="citation-tooltip-doc">{cite.source_doc}</div>
      )}
      {pages && (
        <div className="citation-tooltip-pages">Page {pages}</div>
      )}
      {cite.reference_text && (
        <div className="citation-tooltip-text">{cite.reference_text}</div>
      )}
    </div>
  );
};

export default CitationTooltip;
